const SIMILAR_TO_TODAY_PCT = 80

export const incomeGoalTonePhrase = retirementIncomeGoalPct => {
  if (retirementIncomeGoalPct < SIMILAR_TO_TODAY_PCT) return 'lower than today'
  if (retirementIncomeGoalPct > SIMILAR_TO_TODAY_PCT) return 'higher than today'
  return 'similar to today'
}

export const incomeGoalToneLabel = retirementIncomeGoalPct => {
  const phrase = incomeGoalTonePhrase(retirementIncomeGoalPct)
  return phrase.charAt(0).toUpperCase() + phrase.slice(1)
}

// Engine drops estAftTaxIncomeAtHundredPercent once a goal is saved, so annualize the monthly value.
export const annualIncomeAtHundredPercent = baseCase =>
  baseCase?.estAftTaxIncomeAtHundredPercent ?? (baseCase?.currentAfterTaxIncome ?? 0) * 12

// Pass the replacement percentage as a whole number, such as 80.
export const projectedIncomeValues = ({ retirementIncomeGoalPct, baseCase }) => {
  const todaysAnnual = (retirementIncomeGoalPct / 100) * annualIncomeAtHundredPercent(baseCase)
  const todaysMonthly = todaysAnnual / 12

  // Use zero when the engine has no at-retirement projection.
  const inflationFactor = baseCase?.projectedMonthlyInflationAdjustedRetirementIncFactor ?? 0

  return {
    todaysMonthly,
    todaysAnnual,
    atRetirementMonthly: todaysMonthly * inflationFactor,
    atRetirementAnnual: todaysAnnual * inflationFactor,
  }
}
